export const REACTION_KEYS = ['like', 'love', 'laugh', 'sad', 'angry']

export const REACTION_OPTIONS = [
  { key: 'like', label: 'Like', emoji: '👍' },
  { key: 'love', label: 'Love', emoji: '❤️' },
  { key: 'laugh', label: 'Laugh', emoji: '😂' },
  { key: 'sad', label: 'Sad', emoji: '😢' },
  { key: 'angry', label: 'Angry', emoji: '😡' }
]

export function emptyReactionSummary () {
  const counts = {}
  const usersByType = {}
  REACTION_KEYS.forEach((key) => {
    counts[key] = 0
    usersByType[key] = []
  })
  return { counts, users_by_type: usersByType, current_user_reaction: null }
}
